console.log("VIDEO SECTION JS LOADED");
function initCtVideo(section) {
  section.querySelectorAll('.play-control-btn').forEach(btn => {
    btn.onclick = function () {
      const item = btn.closest('.media-item');
      const video = item.querySelector('video');

      if (!video) return;

      if (video.paused) {
        video.play();
        item.classList.add('is-playing');
      } else {
        video.pause();
        item.classList.remove('is-playing');
      }
    };
  });
}

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('[id^="tk-"]').forEach(initCtVideo);
});

document.addEventListener("shopify:section:load", function (e) {
  initCtVideo(e.target);
});